export const baseUrl = '/treatment-methods'
